import styled from 'styled-components';

const Gradient = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  background-image: linear-gradient(to right, #ff6100, #ffb200, #ffd218);
  padding: 4px 0;
`;

export default Gradient;
